import React, {Component} from 'react';
import {connect} from 'react-redux';

import SimpleChunk from './SimpleChunk';

const Delay = 1000;

class Chunk extends Component {

    constructor(props) {
        super(props);

        this.startLoad = this.startLoad.bind(this);
        this.handleLoad = this.handleLoad.bind(this);

        this.timer = 0;
        this.image = null;
    }

    render() {
        return <SimpleChunk {...this.props} />;
    }

    componentDidMount() {
        const {shouldLoad, distance} = this.props;

        if (shouldLoad) this.prepareLoad(Delay, distance);
    }

    componentWillUnmount() {
        this.abortLoad(false);
    }

    componentDidUpdate() {
        const {shouldLoad, distance, loaded} = this.props;

        if (shouldLoad === false && this.image) return this.abortLoad(loaded);

        if (shouldLoad === loaded) return null;

        if (shouldLoad) {
            if (this.timer === 0) this.prepareLoad(Delay / 4, distance);
        } else {
            this.abortLoad(true);
        }
    }

    prepareLoad(delay, distance) {
        this.timer = setTimeout(this.startLoad, (distance * 50) + delay);
    }

    startLoad() {
        const {url} = this.props;
        const image = this.image = new Image();

        image.addEventListener('load', this.handleLoad);
        image.src = url;
    }

    handleLoad() {
        const {image} = this;

        image.removeEventListener('load', this.handleLoad);

        this.timer = 0;
        this.image = null;

        this.setLoaded(true);
    }

    /**
     * @param {Boolean} updateState
     */
    abortLoad(updateState) {
        const {timer, image} = this;

        if (timer) {
            clearTimeout(timer);
            this.timer = 0;
        }

        if (image) {
            image.removeEventListener('load', this.handleLoad);
            image.src = '';
            this.image = null;
        }

        if (updateState) this.setLoaded(false);
    }

    setLoaded(value) {
        const {index, onLoad} = this.props;

        return onLoad(index, value);
    }

}

const mapStateToProps = ({animationStart, animationStop, index: stateIndex, canPreload}, {index, available}) => ({
    shouldLoad: canPreload && available && index >= animationStart && index <= animationStop,
    distance: Math.abs(index - stateIndex),
});

export default connect(mapStateToProps)(Chunk);
